<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height blue lighten-5 container-background" fluid></v-container>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center" style="z-index:10">
                    <v-col cols="12" sm ="8" md="8">
                        <v-card class="elevation-12">
                            <v-window v-model="step">
                                <v-window-item :value="1"> 
                                    <v-row no-gutters>
                                         <v-col cols="12" md="5" :class="signInClass">
                                            
                                            <v-img
                                                src="../../assets/logo.png"
                                                max-width="180"
                                                contain
                                                class="d-none d-md-flex"
                                            ></v-img>

                                            <v-img
                                                src="../../assets/logo.png"
                                                max-width="70"
                                                contain
                                                class="d-none d-sm-flex d-md-none"
                                            ></v-img>
                                            
                                            <v-card-text class="white--text mt-4">
                                                <div class="text-h5 text-center font-weight-light mb-3">Welcome to </div>
                                                <div class="text-h4 text-sm-h5 text-center">{{ schoolName }}</div>
                                                <div class="text-center mt-3 font-weight-light"> Enter your credentials to begin registration</div>
                                            </v-card-text>
                                            
                                        </v-col>
                                        <v-col cols="12" md="7">
                                            
                                                <v-alert
                                                    outlined
                                                    type="error"
                                                    prominent
                                                    border="left"
                                                    v-if="getloginErrors"
                                                >
                                                    {{ getloginErrors }}
                                                </v-alert>    
                                            
                                            <v-card-text class="mt-10">
                                                <div :class="title_css">Sign in to Register</div>                                            
                                            </v-card-text>
                                            <v-form class="pa-5">
                                                <v-text-field
                                                    label="Student ID"
                                                    placeholder="Enter student ID"
                                                    name="id"                                                
                                                    type="text"
                                                    :color="icon_color"
                                                    v-model="formData.student_id"
                                                    clearable
                                                >
                                                    <v-icon
                                                        slot="prepend"
                                                        :color="icon_color"
                                                    >
                                                        mdi-account
                                                    </v-icon>
                                                </v-text-field>
                                                <v-text-field
                                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                    :type="show ? 'text' : 'password'"
                                                    label="Password"
                                                    placeholder="Enter your birth pin"
                                                    @click:append="show = !show"                                                    
                                                    name="password"
                                                    v-model="formData.password"
                                                    clearable
                                                >
                                                    <v-icon
                                                        slot="prepend"
                                                        :color="icon_color"
                                                    >
                                                        mdi-key
                                                    </v-icon>
                                                </v-text-field>
                                            </v-form>
                                            <div class="text-right mt-1 mr-4 mb-4">                                                
                                                <v-btn :color="icon_color" @click="submit" dark>SIGN IN</v-btn>
                                            </div>
                                            <div>
                                                <v-btn
                                                    text
                                                    color="indigo darken-4"
                                                    class="text-caption mt-5"
                                                    @click="openDialog(true)"
                                                >
                                                    Click here to get your student ID
                                                </v-btn>
                                            </div>
                                        </v-col>                                       
                                    </v-row>                                    
                                </v-window-item>
                                <v-window-item :value="2">

                                </v-window-item>
                            </v-window>
                        </v-card>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
                <query-id/>
            </v-container>            
        </v-main>
        
    </v-app>
</template>

<script>
import QueryId from '../QueryId'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        QueryId,
    },
    data(){
        return {
            step: 1,
            show: false,
            formData: {
                student_id: '',
                password: '',
            },
            loginErrors: '',                        
        }
    },        
    props: {
        source: String,
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',
            primaryColor: 'form/getPrimaryColor',
            colorDarken: 'form/getColorDarken',
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
        }),
        signInClass(){
            return this.primaryColor+' '+this.colorDarken+' d-flex pt-4 flex-column justify-center align-center';
        },
        title_css(){
            return  this.primaryColor+'--text text--'+this.colorDarken+' text-h4 text-left ';
        },
        icon_color(){
             return this.primaryColor+' '+this.colorDarken;
        }
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn'
        }),
        ...mapMutations({
            openDialog: 'auth/setDialog'
        }),
        async submit () {           
            //step++        
            await this.signIn(this.formData);

            if(this.getAuthenticated){
                this.$router.replace('/registration/student-data');   
            }
            else{
                this.loginErrors = this.getLoginErrors                
            }
                                  
        },
        
    }
}
</script>

<style scoped>
    .container-background{
        /* background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%); */
        position: absolute;
    }    

</style>